export const formatCents = (cents) => {
  if(!cents && cents !== 0) return ''
  return '$'+(cents/100).toFixed(2)
}
